<app-loading size="0.5" class="loading-spinner" *ngIf="load else wrapper" color="var(--primary-sec-color)">
</app-loading>
<ng-template #wrapper>
    <div *ngIf="!digiChekId" class="search-customer-wrapper container" style="padding-bottom: 2rem;">
        <mat-accordion multi>
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ 'delivery.vehicleInformation' | translate}}
                    </mat-panel-title>
                    <mat-panel-description class="form-status">
                        <span class="in-complete"
                            *ngIf="!searchVinForm.valid || vehicleDetails.isInvalid  || vehicleDetails.isAlreadyBooked || !vehicleDetails?.yearMakeModel || !vehicleDetails?.vin">{{ 'deliveryChecklist.formIncomplete' | translate}}
                        </span>
                        <span [ngClass]="(vehicleDetails.isSafetyCampaign || vehicleDetails.isDealerDifferent || vehicleDetails.isInvalidCat) ? 'statusLabel' : 'complete'"
                            *ngIf="searchVinForm.valid && !vehicleDetails.isInvalid && !vehicleDetails.isAlreadyBooked && (vehicleDetails?.yearMakeModel && vehicleDetails?.vin)">{{ 'deliveryChecklist.formComplete' | translate}} <span *ngIf="showStatusLabel" [ngClass]="(vehicleDetails.isSafetyCampaign || vehicleDetails.isDealerDifferent || vehicleDetails.isInvalidCat) ? 'statusLabel' : ''">({{ vehicleStatusLabel | translate}})</span></span>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <span class="select-vehicle-header">{{ 'delivery.selectVehicle' | translate}}</span>
                <form class="search-form" [formGroup]="searchVinForm" (ngSubmit)="submitVinForm()">
                    <div class="field-container">
                        <div class="field">
                            <label class="stock-label">{{ 'service.enterTheVin' | translate}}<span
                                    style="color: red">*</span></label>
                            <mat-form-field class="mat-input" appearance="outline">
                                <input type="text" matInput [placeholder]="'service.enterThe17DigitVin' | translate"
                                    (input)="onSearchChange()" formControlName="vin" autocomplete="off" maxlength="300"
                                    required>
                                <mat-error *ngIf=" searchVinForm.controls.vin.errors?.pattern17DigitAndAlphaNumeric">
                                    {{searchVinForm.controls.vin.errors?.pattern17DigitAndAlphaNumeric | translate}}</mat-error>
                                <mat-error *ngIf=" searchVinForm.controls.vin.errors?.pattern17Digit">
                                    {{searchVinForm.controls.vin.errors?.pattern17Digit | translate}}</mat-error>
                                <mat-error *ngIf=" searchVinForm.controls.vin.errors?.patternAlphaNumeric">
                                    {{searchVinForm.controls.vin.errors?.patternAlphaNumeric | translate}}</mat-error>
                            </mat-form-field>
                            <div class="vin-error" *ngIf="vehicleDetails.isInvalid">{{
                                'deliveryChecklist.vehicleNotFoundInNvi' | translate}}</div>
                            <div class="vin-error" *ngIf="vehicleDetails.isInvalidCat || vehicleDetails.isDealerDifferent">
                                {{'deliveryChecklist.deliveryChecklistCanOnlyBeCreatedForVehiclesAtYourLocation' | translate}}<br>
                                {{'deliveryChecklist.canSaveForLaterOnly' | translate}}
                            </div>
                            <div class="vin-error" *ngIf="vehicleDetails.isAlreadyBooked">{{ message | translate}} {{date}}
                            </div>
                        </div>
                        <div class="field buttons">
                            <button type="submit" class="save-btn">
                                <span>{{ 'searchCustomer.search' | translate}}</span>
                            </button>
                        </div>
                    </div>
                </form>
                <app-vehicle-delivery [vehicleDetails]='vehicleDetails' [showSplitter]="false"></app-vehicle-delivery>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="container">
        <div [formGroup]='deliveryForm'>
            <div class="delivery-form">
                <mat-accordion multi>
                    <div *ngIf="digiChekId" class="search-customer-wrapper" style="padding-bottom: 2rem;">
                        <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ 'delivery.vehicleInformation' | translate}}
                                </mat-panel-title>
                                <mat-panel-description class="form-status">
                                    <span [ngClass]="(vehicleDetails.isSafetyCampaign || vehicleDetails.isDealerDifferent || vehicleDetails.isInvalidCat)  ? 'statusLabel' : 'complete'">{{ 'deliveryChecklist.formComplete' | translate}} <span *ngIf="showStatusLabel" [ngClass]="(vehicleDetails.isSafetyCampaign || vehicleDetails.isDealerDifferent || vehicleDetails.isInvalidCat)  ? 'statusLabel' : ''">({{ vehicleStatusLabel | translate}})</span></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <app-vehicle-delivery  [vehicleDetails]='vehicleDetails' [showSplitter]="false"></app-vehicle-delivery>
                        </mat-expansion-panel>
                    </div>
                    <div style="padding-bottom: 2rem;" class="">
                        <mat-expansion-panel [expanded]="!showMandatoryMsgCI && isUpdate">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ 'otherTexts.customerInformation' | translate}}<span style="color: red">*</span>
                                </mat-panel-title>
                                <mat-panel-description class="form-status">
                                    <span class="in-complete" *ngIf="!showMandatoryMsgCI">{{ 'deliveryChecklist.formIncomplete' | translate}}</span>
                                    <span class="complete" *ngIf="showMandatoryMsgCI">{{ 'deliveryChecklist.formComplete' | translate}}</span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <app-contact-email-info formControlName="customer" [customerSearch]="false" (isCIformValid)="isCIformValid($event)" [apptType]="type"></app-contact-email-info>
                        </mat-expansion-panel>
                    </div>

                    <div style="padding-bottom: 3rem;">
                        <mat-expansion-panel [expanded]="isUpdate && (!deliveryForm.controls.salesConsultant.valid || !deliveryForm.controls.dateOfAcquired.valid || !isToday || deliveryForm.controls.dateOfAcquired.dirty)">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ 'navigation.salesAdvisor' | translate}} & {{
                                    'deliveryChecklist.vehicleDeliveryDate' | translate}}<span
                                        style="color: red">*</span>
                                </mat-panel-title>
                                <mat-panel-description class="form-status">
                                    <span class="in-complete" *ngIf="(!deliveryForm.controls.salesConsultant.valid || !deliveryForm.controls.dateOfAcquired.valid)">{{ 'deliveryChecklist.formIncomplete' | translate}}</span>
                                    <span class="complete" *ngIf="(deliveryForm.controls.salesConsultant.valid && deliveryForm.controls.dateOfAcquired.valid)">{{ 'deliveryChecklist.formComplete' | translate}}</span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div>
                                <label class="d-block">{{ 'navigation.salesAdvisor' | translate}}<span
                                        style="color:red">*</span></label>
                                <mat-form-field appearance="outline" class="half-width disabled">
                                    <input matInput [(ngModel)]="loggedInUser" [readonly]="true" formControlName='salesConsultant' required
                                        placeholder="{{'deliveryChecklist.enterTheNameOfTheSalesConsultant' | translate}}">
                                    <mat-error *ngIf="deliveryForm.controls.salesConsultant?.invalid">{{
                                        'deliveryChecklist.pleaseEnterSalesConsultantName' | translate}}</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="date mt-4">
                                <div class="full-width">
                                    <label for="deliveryDate" class="d-block">{{ 'deliveryChecklist.vehicleDeliveryDate' | translate}}<span
                                            style="color:red">*</span> <span *ngIf="!isToday"
                                            style="color: red;margin-left:0.5rem;">({{'deliveryChecklist.differentDates' |
                                            translate }}) </span>
                                    </label>
                                    <mat-form-field appearance="outline" class="half-width">
                                        <input id="deliveryDate" [matDatepicker]="picker" formControlName='dateOfAcquired' matInput
                                            placeholder="{{'departmentHolidays.chooseDate' | translate}}"
                                            [min]="minDate">
                                        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                                        <mat-datepicker #picker (monthSelected)="nextClicked()"></mat-datepicker>
                                        <mat-error *ngIf="deliveryForm.controls.dateOfAcquired?.hasError('required')"
                                            [innerHTML]="'otherTexts.dateIsRequired' | translate">
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                        </mat-expansion-panel>
                    </div>

                </mat-accordion>
            </div>
        </div>
    </div>
</ng-template>